import { Controller } from "react-hook-form";
import { TextField } from "@mui/material";

/**
 * Number field for schedule forms using react-hook-form
 *
 * @param control: react-hook-form control object
 */

interface IProps {
  name: string;
  control: any;
  label: string;
  style?: any;
  readOnly?: boolean;
}

const FormNumberField = (props: IProps) => {
  const { style, name, control, label, readOnly } = props;
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <TextField
          helperText={error ? error.message : null}
          error={!!error}
          onChange={onChange}
          value={value ?? null}
          fullWidth
          label={label}
          variant="outlined"
          sx={{ width: !error ? "70px" : "100%" }}
          size="small"
          type="number"
          inputProps={{ readOnly: readOnly || false }}
        />
      )}
    />
  );
};

export default FormNumberField;
